/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_user = {
    readonly canRequestShippingQuotePermission: boolean | null;
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user">;
    readonly " $refType": "PdpSharedShippingInfoLink_user";
};
export type PdpSharedShippingInfoLink_user$data = PdpSharedShippingInfoLink_user;
export type PdpSharedShippingInfoLink_user$key = {
    readonly " $data"?: PdpSharedShippingInfoLink_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfoLink_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "canRequestShippingQuotePermission",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_REQUEST_SHIPPING_QUOTE"
        }
      ],
      "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    }
  ]
};
(node as any).hash = 'c3f738d67788136e1db4edd3e01dab2f';
export default node;
